/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { HcTrnRequestFormReq } from '../models/hc-trn-request-form-req';
import { HcExportRes } from '../models/hc-export-res';

@Injectable({ providedIn: 'root' })
export class HealthCheckExportDocumentService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `healthCheckExportDocumentRequestFormPost()` */
  static readonly HealthCheckExportDocumentRequestFormPostPath = '/health-check/export-document/request-form';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `healthCheckExportDocumentRequestFormPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  healthCheckExportDocumentRequestFormPost$Response(
    params?: {
      body?: HcTrnRequestFormReq
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<HcExportRes>> {
    const rb = new RequestBuilder(this.rootUrl, HealthCheckExportDocumentService.HealthCheckExportDocumentRequestFormPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<HcExportRes>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `healthCheckExportDocumentRequestFormPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  healthCheckExportDocumentRequestFormPost(
    params?: {
      body?: HcTrnRequestFormReq
    },
    context?: HttpContext
  ): Observable<HcExportRes> {
    return this.healthCheckExportDocumentRequestFormPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<HcExportRes>): HcExportRes => r.body)
    );
  }

}
